function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h16.142v17.071H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#0C2C52",
  fillRule: "nonzero",
  width: 40,
  height: 40,
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.525 10.847)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.56 4.237c-.531-.586-1.34-.879-2.424-.879-.71 0-1.299.12-1.768.36-.47.242-.845.54-1.127.895a3.28 3.28 0 00-.594 1.13 5.128 5.128 0 00-.204 1.067h7.228c-.208-1.13-.578-1.988-1.11-2.573M5.538 12.77c.668.648 1.628.973 2.88.973.896 0 1.668-.224 2.315-.674.646-.45 1.043-.925 1.189-1.428h3.911c-.626 1.946-1.585 3.338-2.879 4.173-1.293.838-2.858 1.256-4.693 1.256-1.273 0-2.42-.204-3.442-.612a7.156 7.156 0 01-2.597-1.741c-.71-.755-1.257-1.653-1.643-2.699C.193 10.973 0 9.822 0 8.567c0-1.213.198-2.343.595-3.389a7.956 7.956 0 011.69-2.714A7.952 7.952 0 014.896.659C5.909.22 7.03 0 8.261 0c1.377 0 2.576.267 3.598.8a7.187 7.187 0 012.52 2.15 8.845 8.845 0 011.423 3.075c.292 1.151.396 2.354.313 3.61H4.443c.063 1.443.428 2.489 1.095 3.136",
  fill: "#FFF",
  mask: "url(#b)"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#008AC6",
  fillRule: "nonzero",
  d: "M30 24h4v4h-4z"
}));

function SvgIconEflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEflow);
export default __webpack_public_path__ + "static/media/icon-eflow.7b1d79c7.svg";
export { ForwardRef as ReactComponent };